var navMainToggle = document.querySelectorAll('[js-menu-toggle]');
var navMainTarget = document.querySelectorAll('[js-menu-target]');

navMainToggle.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
        e.preventDefault();
        navMainTarget.forEach(function (target) {
            if (target.classList.contains('nav-main-open')) {
                target.classList.remove('nav-main-open');
            } else {
                target.classList.add('nav-main-open');
            }
        });
    });
})
